import { IProductComparisonConfiguration } from "../models/product-comparison-configuration";

export const fetchConfiguration = async (id: string, pageId?: string): Promise<IProductComparisonConfiguration> => {
  let url = `/public-api/product-comparison/${id}/configuration`;

  if (pageId) {
    url += `?pageId=${pageId}`;
  }

  const response: Response = await fetch(url);
  return response.ok ? response.json() : Promise.reject();
};
